// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1257) return "static/chunks/1257-5dbd5b3a2b2a4689.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2599":"f10e284a","3524":"dff27125","4849":"4322cd96"}[chunkId] || chunkId) + "." + {"953":"e7ff5c8d9ce61ad6","2599":"cadd5e16940c31f2","3524":"4cad5b92a4274d57","4849":"0f486aa6de97e9d2","8048":"16fa78939d6795c1"}[chunkId] + ".js";
};